// extracted by mini-css-extract-plugin
module.exports = {"root":"ListItemText_root__2AVB6","bold":"ListItemText_bold__23sOm"};